import React, { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

//import localization librabries
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import localization translated json files
import PageLoader from "./components/page_loader.js";

import translationsResources from "./static_assets/localization/resource.ts";
import languageCodes from "./static_assets/localization/languageCodes.json";
import AppWithErrorBoundary from "./routing/ErrorBoundary/index.js";
import ChunkLoadErrorBoundary from "./components/ChunkLoadErrorBoundary.js";
import ScrollToTop from "./components/ScrollToTop.js";
import TawkVisibility from "./components/TawkVisibility.js";
import { markTawkWidgetReady } from "./utils/tawkChat.js";

const AnimatedRoutes = React.lazy(() => import("./routing/animate_routing.js"));

//initialize locatlication in app
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: translationsResources(),
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

i18n.languages = languageCodes;

function App() {
  //set user language
  useEffect(() => {
    try {
      const user_language = localStorage.getItem("language");
      if (user_language) {
        i18n.changeLanguage(user_language);
      }
    } catch (error) {
      console.error("Failed to set language:", error);
    }

    try {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_API.onLoad = function () {
        // Example: Move widget 100px up from bottom
        const styleTag = document.createElement("style");
        styleTag.innerHTML = `
          #tawkchat-container {
            bottom: 100px !important;
          }
        `;
        document.head.appendChild(styleTag);

        markTawkWidgetReady();
      };
    } catch (error) {
      console.error("Failed to initialize Tawk:", error);
    }
  }, []);

  return (
    //wrap app with HelmetProvide for Meta Data integration
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <TawkVisibility />
        <AppWithErrorBoundary>
          <ChunkLoadErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <AnimatedRoutes />
            </Suspense>
          </ChunkLoadErrorBoundary>
        </AppWithErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
